export const bankDetailFields = [
  "marital_status",
  "gps_address",
  "next_of_kin_name",
  "next_of_kin_contact",
  "next_of_kin_relationship",
];

export const emptyFormData = {
  ghana_card_number: "",
  marital_status: "",
  gps_address: "",
  next_of_kin_name: "",
  next_of_kin_contact: "",
  next_of_kin_relationship: "",
};

export const createFormData = (application = {}) => ({
  ghana_card_number: application.ghana_card_number || "",
  marital_status: application.marital_status || "",
  gps_address: application.gps_address || "",
  next_of_kin_name: application.next_of_kin_name || "",
  next_of_kin_contact: application.next_of_kin_contact || "",
  next_of_kin_relationship: application.next_of_kin_relationship || "",
});
